// ไฟล์: frontend/src/components/layout/Header.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Layout.css";

const Header = ({ user, onLogout, systemInfo }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // ปิดเมนูเมื่อคลิกนอกเมนู
  useEffect(() => {
    const closeMenus = () => {
      setMenuOpen(false);
      setUserMenuOpen(false);
    };

    document.addEventListener("click", closeMenus);

    return () => {
      document.removeEventListener("click", closeMenus);
    };
  }, []);

  // จัดการการคลิกเมนู
  const handleMenuClick = (e) => {
    e.stopPropagation();
    setMenuOpen(!menuOpen);
    setUserMenuOpen(false);
  };

  // จัดการการคลิกเมนูผู้ใช้
  const handleUserMenuClick = (e) => {
    e.stopPropagation();
    setUserMenuOpen(!userMenuOpen);
    setMenuOpen(false);
  };

  // จัดการการออกจากระบบ
  const handleLogout = (e) => {
    e.preventDefault();
    onLogout();
    navigate("/");
  };

  // ตรวจสอบว่าเป็นหน้า admin หรือไม่
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <header className={`header ${isAdminPage ? "admin-header" : ""}`}>
      <div className="container-fluid">
        <div className="header-content">
          <div className="header-logo">
            <Link to="/">
              <img src={systemInfo.logo} alt={systemInfo.name} />
              <div className="header-logo-text">
                <h1>{systemInfo.name}</h1>
                <span>{systemInfo.organization}</span>
              </div>
            </Link>
          </div>

          <div className="header-nav-container">
            {/* เมนูสำหรับหน้าจอขนาดเล็ก */}
            <button className="header-menu-toggle" onClick={handleMenuClick}>
              <i className={`fas ${menuOpen ? "fa-times" : "fa-bars"}`}></i>
            </button>

            {/* เมนูหลัก */}
            <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
              <ul>
                <li>
                  <Link
                    to="/"
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    <i className="fas fa-home"></i> หน้าหลัก
                  </Link>
                </li>
                <li>
                  <Link
                    to="/resources"
                    className={
                      location.pathname.startsWith("/resources") ? "active" : ""
                    }
                  >
                    <i className="fas fa-book"></i> สื่อการสอน
                  </Link>
                </li>
                <li>
                  <Link
                    to="/innovations"
                    className={
                      location.pathname.startsWith("/innovations")
                        ? "active"
                        : ""
                    }
                  >
                    <i className="fas fa-lightbulb"></i> นวัตกรรม
                  </Link>
                </li>
                <li>
                  <Link
                    to="/articles"
                    className={
                      location.pathname.startsWith("/articles") ? "active" : ""
                    }
                  >
                    <i className="fas fa-pen-fancy"></i> บทความ
                  </Link>
                </li>
                <li>
                  <Link
                    to="/news"
                    className={
                      location.pathname.startsWith("/news") ? "active" : ""
                    }
                  >
                    <i className="fas fa-newspaper"></i> ข่าวสาร
                  </Link>
                </li>
              </ul>
            </nav>

            {/* เมนูผู้ใช้ */}
            <div className="header-user">
              {user ? (
                <div className="user-dropdown">
                  <button
                    className="user-dropdown-toggle"
                    onClick={handleUserMenuClick}
                  >
                    <div className="user-avatar">
                      <img
                        src={
                          user.profile_image
                            ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${user.profile_image}`
                            : `https://ui-avatars.com/api/?name=${user.fullname}&background=random`
                        }
                        alt={user.fullname}
                      />
                    </div>
                    <span className="user-name">{user.fullname}</span>
                    <i
                      className={`fas ${
                        userMenuOpen ? "fa-chevron-up" : "fa-chevron-down"
                      }`}
                    ></i>
                  </button>

                  {userMenuOpen && (
                    <div className="user-dropdown-menu">
                      {user.role === "admin" && (
                        <Link to="/admin/dashboard" className="dropdown-item">
                          <i className="fas fa-tachometer-alt"></i>{" "}
                          แดชบอร์ดผู้ดูแล
                        </Link>
                      )}
                      <Link to="/dashboard" className="dropdown-item">
                        <i className="fas fa-tachometer-alt"></i> แดชบอร์ดของฉัน
                      </Link>
                      <Link to="/profile" className="dropdown-item">
                        <i className="fas fa-user"></i> โปรไฟล์
                      </Link>
                      <Link to="/library" className="dropdown-item">
                        <i className="fas fa-bookmark"></i> คลังส่วนตัว
                      </Link>
                      <Link to="/upload-resource" className="dropdown-item">
                        <i className="fas fa-upload"></i> อัปโหลดสื่อ
                      </Link>
                      <Link to="/upload-innovation" className="dropdown-item">
                        <i className="fas fa-lightbulb"></i> แชร์นวัตกรรม
                      </Link>
                      <Link to="/write-article" className="dropdown-item">
                        <i className="fas fa-pen"></i> เขียนบทความ
                      </Link>
                      <div className="dropdown-divider"></div>
                      <a
                        href="#logout"
                        className="dropdown-item"
                        onClick={handleLogout}
                      >
                        <i className="fas fa-sign-out-alt"></i> ออกจากระบบ
                      </a>
                    </div>
                  )}
                </div>
              ) : (
                <div className="header-auth">
                  <Link to="/login" className="btn btn-light">
                    <i className="fas fa-sign-in-alt"></i> เข้าสู่ระบบ
                  </Link>
                  <Link to="/register" className="btn btn-primary">
                    <i className="fas fa-user-plus"></i> สมัครสมาชิก
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* เมนูค้นหา */}
      <div className="header-search">
        <div className="container">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              navigate(`/search?query=${e.target.query.value}`);
            }}
          >
            <div className="search-input">
              <i className="fas fa-search"></i>
              <input
                type="text"
                name="query"
                placeholder="      ค้นหาสื่อการสอน นวัตกรรม บทความ..."
              />
              <button type="submit" className="btn btn-primary">
                ค้นหา
              </button>
            </div>
          </form>
        </div>
      </div>
    </header>
  );
};

export default Header;
